/**
 * A list of language codes and the flag that best corresponds to that language. 
 * !NOTE: Flags emojis are not compatible with windows OS.
 */
const flags: Record<string, { emoji: string }> = {
  "af": {
    "emoji": "🇿🇦"
  },
  "am": {
    "emoji": "🇪🇹"
  },
  "ar": {
    "emoji": "🇸🇦"
  },
  "as": {
    "emoji": "🇮🇳"
  },
  "az": {
    "emoji": "🇦🇿"
  },
  "ba": {
    "emoji": "🇷🇺"
  },
  "be": {
    "emoji": "🇧🇾"
  },
  "bg": {
    "emoji": "🇧🇬"
  },
  "bn": {
    "emoji": "🇧🇩"
  },
  "bo": {
    "emoji": "🇨🇳"
  },
  "br": {
    "emoji": "🇫🇷"
  },
  "bs": {
    "emoji": "🇧🇦"
  },
  "ca": {
    "emoji": "🇪🇸"
  },
  "cs": {
    "emoji": "🇨🇿"
  },
  "cy": {
    "emoji": "🇬🇧"
  },
  "da": {
    "emoji": "🇩🇰"
  },
  "de": {
    "emoji": "🇩🇪"
  },
  "dv": {
    "emoji": "🇲🇻"
  },
  "dz": {
    "emoji": "🇧🇹"
  },
  "ee": {
    "emoji": "🇬🇭"
  },
  "el": {
    "emoji": "🇬🇷"
  },
  "en": {
    "emoji": "🇺🇸"
  },
  "eo": {
    "emoji": "🌍"
  },
  "es": {
    "emoji": "🇪🇸"
  },
  "et": {
    "emoji": "🇪🇪"
  },
  "eu": {
    "emoji": "🇪🇸"
  },
  "fa": {
    "emoji": "🇮🇷"
  },
  "fi": {
    "emoji": "🇫🇮"
  },
  "fil": {
    "emoji": "🇵🇭"
  },
  "fo": {
    "emoji": "🇫🇴"
  },
  "fr": {
    "emoji": "🇫🇷"
  },
  "ga": {
    "emoji": "🇮🇪"
  },
  "gd": {
    "emoji": "🏴󠁧󠁢󠁳󠁣󠁴󠁿"
  },
  "gl": {
    "emoji": "🇪🇸"
  },
  "gu": {
    "emoji": "🇮🇳"
  },
  "ha": {
    "emoji": "🇳🇬"
  },
  "he": {
    "emoji": "🇮🇱"
  },
  "hi": {
    "emoji": "🇮🇳"
  },
  "hr": {
    "emoji": "🇭🇷"
  },
  "ht": {
    "emoji": "🇭🇹"
  },
  "hu": {
    "emoji": "🇭🇺"
  },
  "hy": {
    "emoji": "🇦🇲"
  },
  "id": {
    "emoji": "🇮🇩"
  },
  "ig": {
    "emoji": "🇳🇬"
  },
  "is": {
    "emoji": "🇮🇸"
  },
  "it": {
    "emoji": "🇮🇹"
  },
  "iu": {
    "emoji": "🇨🇦"
  },
  "ja": {
    "emoji": "🇯🇵"
  },
  "jv": {
    "emoji": "🇮🇩"
  },
  "ka": {
    "emoji": "🇬🇪"
  },
  "kk": {
    "emoji": "🇰🇿"
  },
  "kl": {
    "emoji": "🇩🇰"
  },
  "km": {
    "emoji": "🇰🇭"
  },
  "kn": {
    "emoji": "🇮🇳"
  },
  "ko": {
    "emoji": "🇰🇷"
  },
  "ks": {
    "emoji": "🇮🇳"
  },
  "ku": {
    "emoji": "🇮🇶"
  },
  "ky": {
    "emoji": "🇰🇬"
  },
  "la": {
    "emoji": "🇻🇦"
  },
  "lb": {
    "emoji": "🇱🇺"
  },
  "lo": {
    "emoji": "🇱🇦"
  },
  "lt": {
    "emoji": "🇱🇹"
  },
  "lv": {
    "emoji": "🇱🇻"
  },
  "mg": {
    "emoji": "🇲🇬"
  },
  "mi": {
    "emoji": "🇳🇿"
  },
  "mk": {
    "emoji": "🇲🇰"
  },
  "ml": {
    "emoji": "🇮🇳"
  },
  "mn": {
    "emoji": "🇲🇳"
  },
  "mr": {
    "emoji": "🇮🇳"
  },
  "ms": {
    "emoji": "🇲🇾"
  },
  "mt": {
    "emoji": "🇲🇹"
  },
  "my": {
    "emoji": "🇲🇲"
  },
  "nb": {
    "emoji": "🇳🇴"
  },
  "ne": {
    "emoji": "🇳🇵"
  },
  "nl": {
    "emoji": "🇳🇱"
  },
  "nn": {
    "emoji": "🇳🇴"
  },
  "no": {
    "emoji": "🇳🇴"
  },
  "ny": {
    "emoji": "🇲🇼"
  },
  "oc": {
    "emoji": "🇫🇷"
  },
  "om": {
    "emoji": "🇪🇹"
  },
  "or": {
    "emoji": "🇮🇳"
  },
  "pa": {
    "emoji": "🇮🇳"
  },
  "pl": {
    "emoji": "🇵🇱"
  },
  "ps": {
    "emoji": "🇦🇫"
  },
  "pt": {
    "emoji": "🇵🇹"
  },
  "qu": {
    "emoji": "🇵🇪"
  },
  "rm": {
    "emoji": "🇨🇭"
  },
  "rn": {
    "emoji": "🇧🇮"
  },
  "ro": {
    "emoji": "🇷🇴"
  },
  "ru": {
    "emoji": "🇷🇺"
  },
  "rw": {
    "emoji": "🇷🇼"
  },
  "se": {
    "emoji": "🇳🇴"
  },
  "sg": {
    "emoji": "🇨🇫"
  },
  "si": {
    "emoji": "🇱🇰"
  },
  "sk": {
    "emoji": "🇸🇰"
  },
  "sl": {
    "emoji": "🇸🇮"
  },
  "sn": {
    "emoji": "🇿🇼"
  },
  "so": {
    "emoji": "🇸🇴"
  },
  "sq": {
    "emoji": "🇦🇱"
  },
  "sr": {
    "emoji": "🇷🇸"
  },
  "sv": {
    "emoji": "🇸🇪"
  },
  "sw": {
    "emoji": "🇹🇿"
  },
  "ta": {
    "emoji": "🇮🇳"
  },
  "te": {
    "emoji": "🇮🇳"
  },
  "tg": {
    "emoji": "🇹🇯"
  },
  "th": {
    "emoji": "🇹🇭"
  },
  "ti": {
    "emoji": "🇪🇷"
  },
  "tk": {
    "emoji": "🇹🇲"
  },
  "tl": {
    "emoji": "🇵🇭"
  },
  "tn": {
    "emoji": "🇿🇦"
  },
  "tr": {
    "emoji": "🇹🇷"
  },
  "ts": {
    "emoji": "🇿🇦"
  },
  "tt": {
    "emoji": "🇷🇺"
  },
  "ug": {
    "emoji": "🇨🇳"
  },
  "uk": {
    "emoji": "🇺🇦"
  },
  "ur": {
    "emoji": "🇵🇰"
  },
  "uz": {
    "emoji": "🇺🇿"
  },
  "vi": {
    "emoji": "🇻🇳"
  },
  "xh": {
    "emoji": "🇿🇦"
  },
  "yi": {
    "emoji": "🇮🇱"
  },
  "yo": {
    "emoji": "🇳🇬"
  },
  "zh": {
    "emoji": "🇨🇳"
  }
}


export default flags;